// he-size-tool.js
(function () {
  const SIZE_MAP = {
    abus:[{s:"S",a:51,b:55},{s:"M",a:52,b:58},{s:"L",a:59,b:61}],
    casco:[{s:"S",a:52,b:56},{s:"M",a:56,b:58},{s:"L",a:58,b:62}],
    uvex:[{s:"XS",a:53,b:54},{s:"S",a:55,b:56},{s:"M",a:57,b:58},{s:"L",a:59,b:60},{s:"XL",a:61,b:62}],
    cratoni:[{s:"S-M",a:52,b:56},{s:"M-L",a:54,b:58},{s:"L-XL",a:58,b:61}],
    nutcase:[{s:"S",a:52,b:56},{s:"M",a:56,b:60},{s:"L",a:60,b:64}],
    cairn:[{s:"S",a:52,b:55},{s:"M",a:56,b:58},{s:"L",a:59,b:62}],
    melon:[{s:"XXS-S",a:46,b:52},{s:"M-L",a:52,b:58},{s:"XL-XXL",a:58,b:63}],
    livall:[{s:"M",a:54,b:58},{s:"L",a:58,b:62}],
    unit1:[{s:"S",a:51,b:55},{s:"M",a:55,b:60},{s:"L",a:60,b:63}],
    tld:[{s:"S",a:54,b:56},{s:"M",a:56,b:58},{s:"L",a:58,b:60},{s:"XL",a:60,b:62}],
    giro:[{s:"S",a:51,b:55},{s:"M",a:55,b:59},{s:"L",a:59,b:63}],
    bell:[{s:"S",a:57,b:57},{s:"M",a:58,b:59},{s:"L",a:60,b:60},{s:"XL",a:61,b:62}],
    poc:[{s:"XS-S",a:51,b:54},{s:"M-L",a:55,b:58},{s:"XL-XXL",a:59,b:62}],
    kask:[{s:"M",a:55,b:58},{s:"L",a:59,b:62}],
    smith:[{s:"S",a:51,b:55},{s:"M",a:55,b:59},{s:"L",a:59,b:63},{s:"XL",a:63,b:67}]
  };

  function bindTool(root){
    const brand = root.querySelector('[data-he="brand"]');
    const head  = root.querySelector('[data-he="head"]');
    const btn   = root.querySelector('[data-he="btn"]');
    const out   = root.querySelector('[data-he="out"]');
    if(!brand || !head || !btn || !out) return;

    btn.addEventListener('click', function(){
      const b = (brand.value || '').toLowerCase().trim();
      const h = parseFloat((head.value || '').replace(',', '.'));
      if(!b || isNaN(h)){ out.textContent = "Bitte Marke und Kopfumfang eingeben."; return; }

      if(b === 'other'){
        out.textContent = "Bei sonstigen Marken bitte Herstellerangaben prüfen. Dein Wert: " + h + " cm.";
        return;
      }
      const ranges = SIZE_MAP[b];
      if(!ranges){ out.textContent = "Für diese Marke liegen uns noch keine Daten vor."; return; }

      const hit = ranges.find(r => h >= r.a && h <= r.b);
      out.textContent = hit ? ("Empfohlene Größe: " + hit.s) : "Keine Standardgröße gefunden – bitte Hersteller prüfen.";
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-he="tool"]').forEach(bindTool);
  });
})();
